// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);
/**
 * @typedef {Object} PaginationOpts
 * @property {string} searchString
 * @property {number} limit
 * @property {number} skip
 */

/**
 * @typedef {Object} Fixture
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} type
 */

/**
 * @typedef {Object} ICD10FixtureBase
 * @property {string} code
 * @property {string} text
 *
 * @typedef {ICD10FixtureBase & Fixture} ICD10Fixture
 */

export const DEFAULT_ICD10_PAGINATION_OPTS = {
  searchString: '',
  limit: 20,
  skip: 0
};

const state = {
  /**
   * list of icd10 fixtures
   * @type {ICD10Fixture[]}
   **/
  icd10: [],
  /**
   * - total number of stored (in db) icd10 fixtures
   * - used for pagination
   * @type {number}
   **/
  icd10Total: 0,
  /**
   * @type {PaginationOpts}
   */
  icd10PaginationOpts: { ...DEFAULT_ICD10_PAGINATION_OPTS }
};

export default state;
